module.exports = __webpack_public_path__ + "img/08219203002200.feec0a12.png";